import { FC, useRef, useState } from 'react'
import { useOnClickOutside } from './Hooks'
import { useKey } from './useKey'
import './Utils.css'

/** Clicking button creates a small popup window allowing selecting a font size based
 * a list showing the sample text in each font size.
 * <Enter> or clicking outside the popup will calls setFontSize and close it.
 * <Escape> will close it without calling setFontSize..
 */

interface IFontSize {
    fontSize: number
    setFontSize: (size: number) => void
    allowedFontSizes: number[]
    onClose: () => void
    sampleText?: string
}

export const FontSizeSelector: FC<IFontSize> = (
    { fontSize, setFontSize, allowedFontSizes, onClose, sampleText }) => {
    const ref = useRef<HTMLDivElement>(null)

    useOnClickOutside(ref, () => onClose())
    useKey('Escape', () => onClose())
    useKey('Enter', () => onClose())

    sampleText = sampleText || 'T'

    return (
        <div
            ref={ref}
            className="font-size-selector"
        >
            {allowedFontSizes.map((_fontSize) => (
                <div
                    key={_fontSize}
                    onClick={() => {
                        setFontSize(_fontSize)
                        onClose()
                    }}
                    className={`font-size-option ${fontSize === _fontSize ? 'font-size-option-selected' : 'font-size-option-normal'}`}
                >
                    <span
                        className="font-size-sample"
                        style={{
                            fontSize: _fontSize,
                        }}
                    >
                        {sampleText + (fontSize === _fontSize ? ' ***' : '')}
                    </span>
                </div>
            ))}
        </div>
    )
}

// Display a button. When clicked, it will open a font size selector.
export const FontSizeSelectorButton: FC<{
    hasLabel: boolean
    fontSize: number
    setFontSize: (size: number) => void
    allowedFontSizes: number[] // allowed font sizes
    onClose: () => void
    sampleText?: string
    tooltip?: string

}> = ({ hasLabel, fontSize, setFontSize, allowedFontSizes, onClose, sampleText, tooltip }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="font-size-selector-container">
            <span
                className="font-size-selector-label"
                onClick={() => hasLabel && setIsOpen(!isOpen)}
                style={{ opacity: hasLabel ? 1 : 0.5, cursor: hasLabel ? 'pointer' : 'default' }}
                title={tooltip} >
                T <span className="font-size-selector-label-minor">T</span>
            </span>
            {isOpen && (
                <FontSizeSelector
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    allowedFontSizes={allowedFontSizes}
                    sampleText={sampleText}
                    onClose={() => {
                        setIsOpen(false)
                        onClose()
                    }}
                />
            )}
        </div>
    )
}
